import React, { createContext, useCallback, useEffect, useState } from 'react'
import Cookies from 'js-cookie'

const THEME_STORAGE_KEY = 'theme'

const normalizeTheme = (value) => {
    const normalized = String(value || '').toUpperCase()
    return normalized === 'DARK' ? 'DARK' : 'LIGHT'
}

const readStoredTheme = () => {
    const params = new URLSearchParams(window.location.search)
    const urlTheme = params.get('theme')
    if (urlTheme) {
        return normalizeTheme(urlTheme)
    }

    const localTheme = localStorage.getItem(THEME_STORAGE_KEY)
    if (localTheme) {
        return normalizeTheme(localTheme)
    }

    return normalizeTheme(Cookies.get(THEME_STORAGE_KEY) || 'LIGHT')
}

const persistTheme = (theme) => {
    const normalized = normalizeTheme(theme)
    const isInIframe = window.self !== window.top

    localStorage.setItem(THEME_STORAGE_KEY, normalized)
    Cookies.set(THEME_STORAGE_KEY, normalized, {
        expires: 365,
        path: '/',
        sameSite: isInIframe ? 'none' : 'lax',
        secure: isInIframe || window.location.protocol === 'https:',
    })

    return normalized
}

const Initial_Theme = {
    theme: readStoredTheme(),
}

export const Theme_Context = createContext({
    Theme: Initial_Theme,
    Set_Theme: () => {},
})

const Theme = ({ children }) => {
    const [Theme, Set_Theme] = useState(Initial_Theme)

    const updateTheme = useCallback((nextTheme) => {
        const normalized = persistTheme(
            typeof nextTheme === 'object' ? nextTheme?.theme : nextTheme
        )
        Set_Theme({ theme: normalized })
        return normalized
    }, [])

    useEffect(() => {
        updateTheme(readStoredTheme())
    }, [updateTheme])

    useEffect(() => {
        document.body.className = Theme.theme === 'DARK' ? 'DARK' : 'LIGHT'
    }, [Theme.theme])

    const setTheme = useCallback((themeOrUpdater) => {
        if (typeof themeOrUpdater === 'function') {
            Set_Theme((prevTheme) => {
                const nextTheme = themeOrUpdater(prevTheme)
                const normalized = persistTheme(
                    typeof nextTheme === 'object' ? nextTheme?.theme : nextTheme
                )
                return { theme: normalized }
            })
            return
        }

        updateTheme(themeOrUpdater)
    }, [updateTheme])

    return (
        <Theme_Context.Provider value={{ Theme, Set_Theme: setTheme }}>
            {children}
        </Theme_Context.Provider>
    )
}

export default Theme